import { Skeleton } from "../ui/skeleton";

export default function MyStacksSectionSkeleton() {
  return (
    <div className="space-y-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="flex items-center gap-3 p-3 rounded-lg">
          <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-32 bg-gray-300" />
            <Skeleton className="h-3 w-24 bg-gray-300" />
          </div>
          <div className="text-right space-y-2">
            <Skeleton className="h-4 w-20 bg-gray-300" />
            <Skeleton className="h-3 w-16 bg-gray-300" />
          </div>
        </div>
      ))}
    </div>
  );
}
